<template>
  <div class="loading-spinner">
    <div class="has-text-centered">
      <i class="fa fa-spinner fa-spin fa-2x mb-3"></i>
      <p class="title is-5">{{ $t("loading") }}...</p>
      <p class="subtitle is-6">{{ $t("loading evaluation data") }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingSpinner",
};
</script>

<style scoped>
.loading-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  padding: 2rem;
  background-color: transparent;
}

.has-text-centered {
  color: hsl(0, 0%, 96%);
}

.title {
  color: hsl(0, 0%, 96%) !important;
}

.subtitle {
  color: hsl(0, 0%, 71%) !important;
}

.fa-spinner {
  color: hsl(171, 100%, 41%);
}

.mb-3 {
  margin-bottom: 0.75rem;
}
</style>
